import { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import API from '../api/client';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      API.get('/auth/me')
        .then((res) => setUser(res.data))
        .catch(() => {
          Cookies.remove('token');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    const res = await API.post('/auth/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    Cookies.set('token', res.data.access_token, { expires: 1 });
    const me = await API.get('/auth/me');
    setUser(me.data);
  };

  const logout = () => {
    Cookies.remove('token');
    setUser(null);
  };

  const isSuperAdmin = user?.role === 'super_admin';
  const isRestaurantUser = user?.role === 'restaurant_user';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isSuperAdmin, isRestaurantUser }}>
      {children}
    </AuthContext.Provider>
  );
};
